import { Component, EventEmitter, Input, Output, AfterViewInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Feedback } from "../../../core/models/feedback";
import { FeedbackService } from "../../../core/services/feedback.service";
import { ToastrService } from "ngx-toastr";
import $ from 'jquery';
import 'summernote';

@Component({
  selector: 'app-feedback',
  standalone: false,
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.css'
})
export class FeedbackComponent implements OnChanges {
  @Input() showModal = false;
  @Output() fecharModalPai = new EventEmitter<void>();

  feedback = new Feedback();

  constructor(
    private feedbackService: FeedbackService,
    private toastr: ToastrService
  ) {}



  ngOnChanges(changes: SimpleChanges) {
    if (changes['showModal']) {
    }
  }



  salvarFeedback() {
    this.feedbackService.adicionar(this.feedback).subscribe(
      result => {
        if(result.sucesso) {
          this.toastr.success("Feedback enviado com sucesso. Agradecemos e vamos trabalhar para melhorar nosso sistema!");
          this.feedback = new Feedback();
          this.fecharModal();
        }
      }
    );
  }

  fecharModal() {
    this.showModal = false;
    this.fecharModalPai.emit();
  }

  onBackgroundClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.fecharModal();
    }
  }
}
